module.exports = (__webpack_require__(0))(322);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/metadatumEditWidget.pug from dll-reference girder_lib
// module id = 165
// module chunks = 0